import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { UserDto } from "@dashboard/modules/management/user/model/user.dto";
import { AuthService } from "@app/modules/shared/services/auth.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";

@Component({
  selector: "kl-lock-screen",
  templateUrl: "./lock-screen.component.html",
  styleUrls: ["./lock-screen.component.scss"],
})
export class LockScreenComponent implements OnInit {
  headers: HttpHeaders = new HttpHeaders().set(
    "Authorization",
    "Bearer " + localStorage.getItem("access_token")
  );
  user: UserDto;
  password: string;
  alertMessage = "";
  apiError = false;
  invalidPassword = false;
  currentYear: number;
  body = document.querySelector("body");
  currentLanguage = localStorage.getItem("currentLanguage");
  @ViewChild("LockScreenForm", { static: true }) private lockScreenForm: any;

  static get apiUrl() {
    return localStorage.getItem("apiUrl")
      ? localStorage.getItem("apiUrl")
      : environment.apiUrl;
  }

  constructor(
    private router: Router,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private explorerService: ExplorerService,
    private authService: AuthService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.translateService.use(this.currentLanguage);
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.body.classList.add("lock-screen");
    this.http
      .get(LockScreenComponent.apiUrl + "/user/my", { headers: this.headers })
      .subscribe(
        (responseUser: any) => {
          this.user = responseUser.data;
        },
        () => {
          this.router.navigateByUrl("/auth/login");
        }
      );
  }

  login() {
    if (this.lockScreenForm.valid) {
      const user = {
        username: this.user.username,
        password: this.password,
        grant_type: "password",
      };
      this.klLoadingService.show("loading");
      this.authService.login(user).subscribe(
        (loginResponse) => {
          if (loginResponse === undefined) {
            this.alertMessage =
              this.utilService.alertErrorMessage("error_data");
            this.apiError = true;
            this.klLoadingService.hide();
          } else {
            localStorage.removeItem("lock-screen");
            this.klLoadingService.hide();
            UtilService.saveLocalStorage({ token_date: new Date().getTime() });
            UtilService.saveLocalStorage(loginResponse);
            this.apiError = false;
            this.body.classList.remove("lock-screen");
            return this.router.navigateByUrl("/dashboard");
          }
        },
        (error) => {
          this.toastService.toastError(
            this.utilService.alertErrorMessage(error),
            4000
          );
          this.klLoadingService.hide();
        }
      );
    } else {
      this.invalidPassword = true;
    }
  }

  translate(text) {
    return this.translateService.instant(text);
  }

  routerLink(link) {
    return this.router.navigateByUrl(link);
  }
}
